import { registerOverlay } from '../overlay';
import Transaction from './transaction.svelte';
import Create from './create.svelte';
import AccountChoice from './account-choice.svelte';
import NewAccount from './new-account.svelte';
export const transactionOverlay = registerOverlay(Transaction);
export const createOverlay = registerOverlay(Create);
export const accountChoiceOverlay = registerOverlay(AccountChoice);
export const newAccountOverlay = registerOverlay(NewAccount);
